import apiClient from './client';

export interface Task {
  id: number;
  lead_id?: number;
  account_id?: number;
  lead_name?: string;
  lead_stage?: string;
  account_name?: string;
  assigned_to: number;
  assigned_to_name?: string;
  title: string;
  description?: string;
  status: string;
  priority?: string;
  due_date?: string;
  created_at: string;
  updated_at: string;
}

export interface TasksResponse {
  success: boolean;
  data: Task[];
}

export const tasksApi = {
  getAll: async (): Promise<Task[]> => {
    const response = await apiClient.get<TasksResponse>('/follow-up-tasks');
    return response.data.data;
  },
  create: async (task: Partial<Task>): Promise<Task> => {
    const response = await apiClient.post<{ success: boolean; data: Task }>('/follow-up-tasks', task);
    return response.data.data;
  },
  update: async (id: number, task: Partial<Task>): Promise<Task> => {
    const response = await apiClient.patch<{ success: boolean; data: Task }>(`/follow-up-tasks/${id}`, task);
    return response.data.data;
  },
  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/follow-up-tasks/${id}`);
  },
};

